import { IconButton, InputAdornment, Paper, TextField, Typography } from "@mui/material";
import { Analytics, Cancel, Edit, Save } from "@mui/icons-material";

import { RTFOISIPDataTable } from "./RTFOISIPDataTable";
import { RTFOISIPChart } from "./RTFOISIPChart";
import { useEffect, useState } from "react";

export const RTFOISIP = ({ theme, darkMode, currentRTFO, currentWellName='All'}) => {
  const currentStage = currentRTFO?.stageData?.[currentRTFO?.currentStageName];

  const [isip, setISIP] = useState(currentStage?.metrics?.isip?.toFixed(2));
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    setISIP(currentStage?.metrics?.isip?.toFixed(2));
    setIsEditMode(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentRTFO?.currentStageName]);

  return (
    <Paper elevation={0} sx={{boxShadow: 1}} style={{padding: '20px', margin: '10px 20px', display: 'flex', flexDirection: 'column', justifyContent: 'center', backgroundColor: (theme?.palette?.elevationOne?.[(darkMode ? 'dark' : 'light')])}}>
      
      <Typography variant="h6" style={{marginBottom: '20px'}}>
        ISIP Analysis
      </Typography>
      
      <div style={{height: 900, width: '100%', display: 'flex', justifyContent: 'space-between'}}>
        <div style={{width: '50%'}}>
          <RTFOISIPDataTable currentRTFO={currentRTFO} />
        </div>

        {/* <div style={{width: '50%', height: 540, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', position: 'relative'}}>
          <div style={{display: 'flex', position: 'absolute', top: 10, left: 10}}>
            <ToggleButtonGroup
              value={editMode}
              exclusive
              onChange={(e, newType) => setEditMode(newType)}
              size="small"
              style={{height: 24, zIndex: 420}}
              disabled={currentStage?.fracModelLocked}
            >
              <ToggleButton value="start" size="small" title="Edit ISIP Start" color={(darkMode ? "" : "primary")}>
                <VerticalAlignBottom style={{transform: 'rotate(90deg)', fontSize: '16px'}} />
              </ToggleButton>
              <ToggleButton value="end" size="small" title="Edit ISIP End" color={(darkMode ? "" : "primary")}>
                <VerticalAlignBottom style={{transform: 'rotate(-90deg)', fontSize: '16px'}} />
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
          
          <RTFOEditISIPChart gridView={gridView} isip={isip} isipTimestamps={isipTimestamps} setISIPTimestamps={setISIPTimestamps} />
        </div> */}

        <div style={{width: '50%', height: 540, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          {currentStage && currentStage?.metrics?.isip > 0 ?
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div style={{width: 600, display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 20, marginTop: 80, height: 40}}>
              <Typography variant="caption">Surface ISIP:</Typography>
              <TextField
                label="Surface ISIP"
                value={isip}
                onChange={handleISIPChange}
                size="small"
                style={{marginRight: 10, marginLeft: 10}}
                InputProps={{
                  endAdornment: <InputAdornment position="end">MPa</InputAdornment>,
                }}
                disabled={!isEditMode}
              />
              {!isEditMode && <IconButton onClick={() => setIsEditMode(true)} size="small" disabled><Edit /></IconButton>}
              {isEditMode && <IconButton onClick={handleCancel} size="small"><Cancel /></IconButton>}
              {isEditMode && <IconButton size="small" disabled={!isEditMode} style={{marginLeft: 10}}><Save /></IconButton>}
            </div>
            <div style={{ width: '100%', height: 540, marginTop: 20}}>
              <RTFOISIPChart gridView={true} showSpikeLines={true} wellName={currentWellName} /> 
            </div>
          </div> :
          currentStage && !currentStage?.metrics?.isip > 0 ?
          <div style={{
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            justifyContent: 'center',
          }}>
            <Analytics style={{fontSize: '72px', color: 'grey'}} />
            <Typography variant="body2" style={{color: 'grey'}}>ISIP not available</Typography>
          </div> :
          <div>
            <Typography variant="body2" style={{color: 'grey'}}>No data selected</Typography>
          </div>
          }
        </div>  

      </div>
      
    </Paper>
  );

  function handleCancel() {
    setISIP(currentStage?.metrics?.isip?.toFixed(2));
    setIsEditMode(false);
  };

  function handleISIPChange(e) {
    const value = e.target.value;
    const newISIP = +value;

    if (typeof newISIP === 'number') {
      const stageName = currentRTFO?.currentStageName;
      const wellName = stageName?.split('_')?.[1];
      const stageNumber = String(Number(String(stageName?.split('_')?.[2])?.replace(/[^0-9.]+/g, '')?.trim()));
      const stageClusters = currentRTFO?.perfSchedule?.wells?.[wellName?.toLowerCase()]?.stages?.[stageNumber]?.clusters;
      const depths = stageClusters ? Object.keys(stageClusters)?.map(cluster => stageClusters[cluster]?.shotDepth) : [];
      const mdAvg = (depths?.reduce((tot, curr) => tot + curr, 0) / depths?.length) || 0;
      const tvd = (currentRTFO?.surveys?.wells?.[wellName?.toLowerCase()]?.surveyData?.find(data => data.measuredDepth >= mdAvg)?.trueVerticalDepth) || 0;
  
      const isipBH = (newISIP * 1000 + tvd * 9.8) / 1000;
      const fracGradient = (isipBH * 1000 / tvd) || 0;


      console.log({type: typeof newISIP, newISIP, mdAvg, tvd, isipBH, fracGradient});

    }

    setISIP(value);
  }
};